import React, { useState } from 'react';
import { Box, Typography, Grid, makeStyles, Container } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import { Mail } from '@material-ui/icons';
import YeuCauBaoGiaModal from '../../modal/YeuCauBaoGiaModal';
import DangKyLaiThuModal from '../../modal/DangKyLaiThuModal';
import DatLichbaoDuongModal from '../../modal/DatLichbaoDuongModal';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(5),
        backgroundColor: '#003087', // Màu nền xanh đậm
        color: '#fff',             // Màu chữ trắng
        padding: theme.spacing(4),       // Padding đều
    },
    heading: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
        marginBottom: theme.spacing(2),
    },
    text: {
        fontSize: '0.8rem',
        marginBottom: theme.spacing(1),
    },
    link: {
        color: '#fff',
        textDecoration: 'none',
        fontSize: '0.8rem',
        marginBottom: theme.spacing(1),
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    image: {
        width: '100%',         // Đảm bảo ảnh vừa với container
        height: 'auto',        // Giữ tỷ lệ khung hình
        borderRadius: theme.spacing(1), // Nếu có border-radius
    },
    gridItem: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column'
    },
    icon: {
        fontSize: '1rem !important'
    }
}));

const Footer = () => {
    const classes = useStyles();

    const [isModalOpenYeuCauBaoGia, setIsModalOpenYeuCauBaoGia] = useState(false);
    const handleOpenModalYeuCauBaoGia = () => {
        setIsModalOpenYeuCauBaoGia(true);
    };
    const handleCloseModalYeuCauBaoGia = () => {
        setIsModalOpenYeuCauBaoGia(false);
    };

    const [isModalOpenDangKyLaiThu, setIsModalOpenDangKyLaiThu] = useState(false);
    const handleOpenModalDangKyLaiThu = () => {
        setIsModalOpenDangKyLaiThu(true);
    };
    const handleCloseModalDangKyLaiThu = () => {
        setIsModalOpenDangKyLaiThu(false);
    };

    const [isModalOpenBaoDuong, setIsModalOpenBaoDuong] = useState(false);
    const handleOpenModalBaoDuong = () => {
        setIsModalOpenBaoDuong(true);
    };
    const handleCloseModalBaoDuong = () => {
        setIsModalOpenBaoDuong(false);
    };

    return (
        <Box className={classes.root}>
            <Grid container>
                {/* Thông tin công ty */}


                {/* Dịch vụ & Tư vấn */}
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                    <Typography variant="h6" className={classes.heading}>
                        MUA XE
                    </Typography>
                    <Typography component="span" className={classes.link} onClick={handleOpenModalYeuCauBaoGia}>
                        Yêu cầu báo giá
                    </Typography>
                    <Typography component="span" className={classes.link} onClick={handleOpenModalDangKyLaiThu}>
                        Đăng ký lái thử
                    </Typography>
                    <Typography component="span" className={classes.link} onClick={handleOpenModalBaoDuong}>
                        Đặt lịch bảo dưỡng
                    </Typography>
                    <Typography component="a" href="#" className={classes.link}>
                        Mua xe trả góp
                    </Typography>
                </Grid>

                {/* Hỗ trợ khách hàng */}
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                    <Typography variant="h6" className={classes.heading}>
                        DỊCH VỤ
                    </Typography>
                    <Typography component="a" href="/gioi-thieu-dich-vu" className={classes.link}>
                        Giới thiệu về hoạt động Dịch vụ tại Đại lý Thái Nguyên Ford
                    </Typography>
                    <Typography component="a" href="/bao-hanh-tieu-chuan" className={classes.link}>
                        Bảo hành tiêu chuẩn
                    </Typography>
                    <Typography component="a" href="/phu-tung-phu-kien" className={classes.link}>
                        Phụ tùng và phụ kiện chính hãng ford
                    </Typography>
                    <Typography component="a" href="#" className={classes.link}>
                        Chăm sóc khách hàng
                    </Typography>
                    <Typography component="a" href="/bao-hanh-mo-rong" className={classes.link}>
                        Bảo hành mở rộng
                    </Typography>
                </Grid>

                {/* Tin nổi bật */}
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                    <Typography variant="h6" className={classes.heading}>
                        THÁI NGUYÊN FORD
                    </Typography>
                    <Typography component="a" href="#" className={classes.link}>
                        Về chúng tôi
                    </Typography>
                    <Typography component="a" href="#" className={classes.link}>
                        Thông điệp của lãnh đạo Thái Nguyên Ford
                    </Typography>

                </Grid>
                <Grid item xs={12} sm={6} md={3} className={classes.gridItem}>
                    <Typography variant="h6" className={classes.heading}>
                        THÔNG TIN CÔNG TY
                    </Typography>
                    <Typography className={classes.text}>
                        CÔNG TY CỔ PHẦN Ô TÔ TNF
                    </Typography>
                    <Typography className={classes.text}>
                        <LocationOnIcon className={classes.icon} /> Địa chỉ: Đ.Cách Mạng Tháng Tám, P.Cam Giá, TP.Thái Nguyên
                    </Typography>
                    <Typography className={classes.text}>
                        <PhoneIcon className={classes.icon} /> Hotline: 0966.122.815
                    </Typography>
                    <Typography className={classes.text}>
                        <Mail className={classes.icon} /> Email: minhquanhh99@gmail.com
                    </Typography>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3710.6006538008737!2d105.85240527585155!3d21.562464969232845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x313521ab2284efe5%3A0x134f7ffed86655a8!2zRm9yZCBUaMOhaSBOZ3V5w6pu!5e0!3m2!1svi!2s!4v1748658640915!5m2!1svi!2s" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </Grid>
            </Grid>

            <YeuCauBaoGiaModal
                open={isModalOpenYeuCauBaoGia}
                onClose={handleCloseModalYeuCauBaoGia}
            />

            <DangKyLaiThuModal
                open={isModalOpenDangKyLaiThu}
                onClose={handleCloseModalDangKyLaiThu}
            />

            <DatLichbaoDuongModal
                open={isModalOpenBaoDuong}
                onClose={handleCloseModalBaoDuong}
            />
        </Box>
    );
};

export default Footer;
